import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy alias — permanent redirect to the canonical character page.
export const Route = createFileRoute("/meet/$name")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/characters/$name",
      params: { name: params.name },
      replace: true,
      statusCode: 301,
    });
  },
});
